//tipos
import { GetterTree } from "vuex";
import { State } from "@/typings/store";
import { StateIngresos } from "@/typings/store/plugins/easyFirestore/ingresos";

const getters: GetterTree<StateIngresos, State> = {
    get(state) {
        return state.all;
    },
    getArray(state) {
        return Object.values(state.all);
    },
};

const ingresos = {
    firestorePath: "dev/v1/ingresos",
    firestoreRefType: "collection",
    moduleName: "ingresos",
    statePropName: "all",
    namespaced: true,
    serverChange: {
        convertTimestamps: {
            created_at: "%convertTimestamp%", // default
            updated_at: "%convertTimestamp%", // default
        },
    },
    state: {},
    getters,
    mutations: {},
    actions: {},
};

export default ingresos;
